@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

.details-panel-wrapper {
  padding: 20px;

  .details-panel {
    padding: 10px;

    .details-panel-header {
      margin-bottom: 25px;
    }

    .details-panel-content-title {
      text-transform: uppercase;
    }

    .section-title {
      color: var(--chart-300-icon-buttons);
    }

    table {
      width: 100%;
    }

    .label-container {
      text-align: left;
    }

    .details-panel-details-wrapper {
      padding-top: 50px;

      gz-text {
        line-height: 1.27;
      }
    }

    .details-panel-actions {
      position: absolute;
      bottom: 20px;
      display: flex;

      gz-button {
        --button-max-width: 185px;
      }
    }

    .labeled-value {
      line-height: 1.5;
      margin-top: -4px;
    }
  }

  gz-text[class='labeled-value'] {
    display: inline;
  }
  gz-tooltip {
    display: block;
  }
}

gz-labeled-content {
  &::part(content) {
    color: var(--main-titles-inputs-600);
  }
}

.border-top {
  border-top: 1px solid var(--chart-101-pressed-dividers);
}
